import React from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as GatewayTimeoutImage } from 'assets/svg/403-access-denied.svg'
import { ReactComponent as FixtabLogoWithTextImage } from 'assets/svg/fixtab-logo-with-text.svg'

import { currentVersion } from 'helpers/common'
import { redirectMainPage } from './management'

export const Error403Container = (): JSX.Element => {
  const { t } = useTranslation(['common', 'error'])

  return (
    <>
      <div className='con__error'>
        <div className='con__error__header'>
          <FixtabLogoWithTextImage />
        </div>

        <div className='con__error__body'>
          <GatewayTimeoutImage />

          <span className='con__error__title'>
            {t('error:accessDenied.title')}
          </span>

          <span className='con__error__content'>
            {t('error:accessDenied.content')}
          </span>

          <button className='con__error__btn' onClick={redirectMainPage}>
            <span>{t('common:mainPageFixtab.label')}</span>
          </button>
        </div>

        <div className='con__error__footer'>
          <span>
            {t('common:version.label')} {currentVersion}
          </span>
        </div>
      </div>
    </>
  )
}
